module.exports = {
  DESPATCH_CLOSED_DATE: 'DESPATCH_CLOSED_DATE',
  DESPATCH_PLANNED_DEPARTURE_DATE: 'DESPATCH_PLANNED_DEPARTURE_DATE',
  DESPATCH_PLANNED_ARRIVAL_DATE: 'DESPATCH_PLANNED_ARRIVAL_DATE',
  INTERCHANGE_PREPARATION_DATE: 'INTERCHANGE_PREPARATION_DATE',
  CONSIGNMENT_COMPLETION_DATE: 'CONSIGNMENT_COMPLETION_DATE',
  ON_NETWORK_DATE: 'ON_NETWORK_DATE',
  POSTAL_SCAN_DATE: 'POSTAL_SCAN_DATE',
  HANDOVER_REGISTRATION_TIME: 'HANDOVER_REGISTRATION_TIME',
  HANDOVER_REGISTRATION_DATE: 'HANDOVER_REGISTRATION_DATE',
  CARDIT_CONSIGNMENT_COMPLETION_DATE: 'CARDIT_CONSIGNMENT_COMPLETION_DATE',
  CARDIT_FIRST_LEG_PLANNED_DEPARTURE_DATE: 'CARDIT_FIRST_LEG_PLANNED_DEPARTURE_DATE',
  MESSAGE_PREPARATION_DATE: 'MESSAGE_PREPARATION_DATE',
  CARDIT_PLANNED_DEPARTURE_DATE: 'CARDIT_PLANNED_DEPARTURE_DATE',
  CARDIT_PLANNED_ARRIVAL_DATE: 'CARDIT_PLANNED_ARRIVAL_DATE',
  MRD_HANDOVER_REGISTRATION_DATE: 'MRD_HANDOVER_REGISTRATION_DATE',
  PERIOD: 'PERIOD',
  BASE_DATE_RANGE: 'BASE_DATE_RANGE',
  EVENT_DATE: 'EVENT_DATE',
  REPORT_GENERATION_DATE: 'REPORT_GENERATION_DATE',
  ENTRY_DATE: 'ENTRY_DATE',
  LEG3_START_DATE: 'LEG3_START_DATE',
};
